import { useCurrentOrganization } from '~publish/contexts/AccountContext'
import { usePostCounts } from '~publish/pages/AllChannels/PostList/usePostCounts'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

export const useSelectedChannelPostCount = (): number => {
  const organizationId = useCurrentOrganization()?.id
  const selectedChannel = useSelectedChannel()
  const selectedChannelId = selectedChannel?.id
  const { counts } = usePostCounts({
    organizationId,
    channelIds: selectedChannelId ? [selectedChannelId] : undefined,
  })
  const numberOfScheduledPosts = counts?.queue ?? 0
  return numberOfScheduledPosts
}
